module.exports = __webpack_public_path__ + "img/as.1baae629.svg";